import script from "./GastosList.vue?vue&type=script&setup=true&lang=js"
export * from "./GastosList.vue?vue&type=script&setup=true&lang=js"

import "./GastosList.vue?vue&type=style&index=0&id=6439f8d1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6439f8d1"]])

export default __exports__